import { useState, useMemo, ReactNode } from 'react'
import FormRow, { FormRowProps } from 'components/FormRow'
import AdvancedComboBox, { AdvancedComboBoxProps } from 'components/AdvancedComboBox'
import { ProductClassesQuery } from '../../../../../graphql'

import useProductClassesSearch from '../../../parts/hooks/productClassesSearch'

type ProductClassNode = ProductClassesQuery['productClasses']['edges'][number]['node']

export type ProductClassPickerProps = {
	id?: string,
	debounceKey?: string,
	isDisabled?: boolean,
	label?: ReactNode,
	onChange: ( id?: string, option?: ProductClassNode ) => void,
	selectedProductClass?: ProductClassNode,
	required?: boolean,
	formRowProps?: Partial<FormRowProps>,
} & Partial<Omit<AdvancedComboBoxProps<ProductClassNode>, 'onChange'>>

export default function ProductClassPicker( { debounceKey, selectedProductClass, onChange, label, formRowProps, ...props }: ProductClassPickerProps ) {
	const [ searchString, setSearchString ] = useState( '' )
	const { loading, data } = useProductClassesSearch( searchString, debounceKey )

	const productClasses = useMemo( () => data?.productClasses?.edges.map( ( edge ) => edge.node ) ?? [], [ data ] )

	const handleChange = ( productClass?: ProductClassNode ) => {
		onChange( productClass?.id, productClass )
	}

	return (
		<FormRow label={label ?? 'CAT/CLASS'} {...formRowProps}>
			<AdvancedComboBox
				debounceDelayMs={400}
				setSearchString={setSearchString}
				setSelectedOption={handleChange}
				data={productClasses}
				selectedOption={selectedProductClass}
				getName={( productClass ) => productClass.classification}
				getSecondaryText={( productClass ) => [ productClass.categoryName, productClass.catClass ]}
				isLoading={loading}
				{...props}
			/>
		</FormRow>
	)
}
